import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CampaignsPage from './pages/CampaignsPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import PaymentsPage from './pages/PaymentsPage';
import SettingsPage from './pages/SettingsPage';
import OnboardingPage from './pages/OnboardingPage';
import AppShell from './components/layout/AppShell';
import OAuthCallback from './components/auth/OAuthCallback';
import TakeoverDetailPage from './pages/TakeoverDetailPage';

function OAuthQueryGuard({ children }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  if (
    location.pathname !== '/auth/twitter/cb' &&
    params.get('code') &&
    params.get('state')
  ) {
    return <Navigate to={`/auth/twitter/cb${location.search}`} replace />;
  }

  return children;
}

export function isCreatorDevAuthEnabled(environment = process.env) {
  return environment.NODE_ENV !== 'production' &&
    environment.REACT_APP_ENABLE_DEV_AUTH === 'true';
}

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
      <BrowserRouter>
        <OAuthQueryGuard>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/auth/twitter/cb" element={<OAuthCallback provider="twitter" />} />

            <Route
              path="/auth/dev-callback"
              element={isCreatorDevAuthEnabled()
                ? <OAuthCallback provider="dev" />
                : <Navigate to="/login" replace />}
            />
            <Route path="/" element={<AppShell />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="campaigns" element={<CampaignsPage />} />
              <Route path="campaigns/:id" element={<CampaignDetailPage />} />
              <Route path="takeover/:id" element={<TakeoverDetailPage />} />
              <Route path="payments" element={<PaymentsPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Routes>
        </OAuthQueryGuard>
      </BrowserRouter>
      </DataProvider>
    </AuthProvider>
  );
}
